<div class="thp-form-container">
  <div class="thp-message">
    {{"talent-happy-path.talent-profile.splash-page.content" | translate}}
  </div>
  <div class="button-container">
    <button type="button" mat-flat-button id="talent-profile-start-button" class="next-button" (click)="goToEmploymentOpportunities($event)">{{"talent-happy-path.talent-profile.splash-page.complete-profile-button" | translate}}</button>
    <button type="button" mat-button id="talent-profile-do-later-button"  class="later-button" (click)="openDoLaterModal($event)">{{"talent-happy-path.buttons.do-later" | translate}}</button>
    <app-confirmation-modal
      [isVisible]="isModalVisible"
      (isVisibleChange)="isModalVisible = $event"
      header="{{'talent-happy-path.talent-profile.later-modal.header' | translate}}"
      description="{{'talent-happy-path.talent-profile.later-modal.description' | translate}}"
      (cancel)="isModalVisible = false"
      (confirm)="doThisLater(); isModalVisible = false">
    </app-confirmation-modal>
  </div>
</div>
